
<ng-container *ngIf="item;else noItem">
    <div class="row">
        <div class="col-4">
            <p>ID: <strong>{{ item.idRilievo }}</strong></p>
        </div>
        <div class="col-4">
            <p>Nome rilievo: <strong>{{ item.nome }}</strong></p>
        </div>
        <div class="col-4">
            <p>Soggetto esecutore del rilievo: <strong>{{ item.soggettoEsecutore }}</strong></p>
        </div>
        <div class="col-4">
            <p>Descrizione: <strong>{{ item.descrizione }}</strong></p>
        </div>
        <div class="col-4">
            <p>Data inizio: <strong>{{ item.dataInizioRilievo | date: 'dd/MM/yyyy' }}</strong></p>
        </div>
        <div class="col-4">
            <p>Data fine: <strong>{{ item.dataFineRilievo | date: 'dd/MM/yyyy' }}</strong></p>
        </div>
    </div>
</ng-container>
<ng-template #noItem ><p class="mb-0 text-center">Nessun rilievo associato.</p></ng-template>
<div class="button-actions">
    <button *ngIf="item" type="button" class="btn btn-outline-primary"
        (click)="goToRilievo(item.idRilievo)"
        container="body" ngbTooltip="Accedi al dettaglio">
        <app-toolkit-bl-icon icon="arrow-right" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
        Vai al dettaglio
    </button>
    <button *ngIf="canEdit" type="button" class="btn btn-outline-primary" (click)="addItem()">
        <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
        Associa rilievo
    </button>
</div>
